import { CartItemOptions, Variant } from 'service/types';

type optionsSelectedPriceType = ({
  selectedOptions,
  selectedVariant,
}: {
  selectedOptions: Array<CartItemOptions>;
  selectedVariant: Variant;
}) => number;

export const optionsSelectedPrice: optionsSelectedPriceType = ({ selectedOptions, selectedVariant }) => {
  const optionGroupPrices = selectedVariant?.optionGroups.map(group => {
    const groupSelectedOptions = selectedOptions
      .filter(selectedOption => selectedOption.optionGroupId === group.uuid)
      .map(selectedOption => {
        const optionSelected = group.options?.find(option => option.uuid === selectedOption.optionId);
        return {
          price: optionSelected?.price || 0,
          quantity: selectedOption.optionQuantity || 0,
        };
      });

    const sortedOptions = groupSelectedOptions.sort((a, b) => a.price - b.price);

    let remainingFreeOptions = group.freeOptionsCount;

    const totalGroupPrice = sortedOptions.reduce((acc, { price, quantity }) => {
      if (remainingFreeOptions > 0) {
        const freeQuantity = Math.min(quantity, remainingFreeOptions);
        remainingFreeOptions -= freeQuantity;
        const paidQuantity = quantity - freeQuantity;
        return acc + price * paidQuantity;
      }

      return acc + price * quantity;
    }, 0);

    return totalGroupPrice;
  });
  const totalOptionPrice = optionGroupPrices?.reduce((acc, currValue) => acc + currValue, 0) || 0;
  return totalOptionPrice;
};
